import { isConstrainedNetwork } from "./constrained-network";

export function shouldPreloadOnIntent(): boolean {
    return typeof window !== "undefined" && !isConstrainedNetwork();
}
